import { Maybe, QuizRetakeTypeEnum, QuizSettings } from '@/types/schema';

type RetakeSettings = Maybe<Pick<QuizSettings, 'retakeType' | 'retakeAllowedCount'>> | undefined;

class QuizSettingsEntity {
  static getDefaultRetakeSettings() {
    return {
      retakeType: QuizRetakeTypeEnum.Everyone,
      retakeAllowedCount: 100,
    };
  }

  static getRetakeSettings(settings: RetakeSettings) {
    if (!settings?.retakeType) {
      return {
        retakeType: QuizRetakeTypeEnum.None,
        retakeAllowedCount: 0,
      };
    }
    return {
      retakeType: settings.retakeType,
      retakeAllowedCount: settings?.retakeAllowedCount ?? 0,
    };
  }

  static getAllowedAttempts(settings: RetakeSettings) {
    const { retakeType, retakeAllowedCount } = this.getRetakeSettings(settings);
    return retakeType === QuizRetakeTypeEnum.None ? 1 : retakeAllowedCount + 1;
  }
}

export default QuizSettingsEntity;
